// ...existing code... (update all emerald to auburn)
import React, { useState } from 'react'
import { Phone, Mail, MapPin, Clock, Send } from 'lucide-react'
import toast from 'react-hot-toast'

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    
    const subject = encodeURIComponent('Service Request from ' + formData.name)
    const body = encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\nPhone: ${formData.phone}\n\nMessage:\n${formData.message}`
    )
    
    window.location.href = `mailto:service@refugecommunityoutreach.org?subject=${subject}&body=${body}`
    
    toast.success('Opening your email client...')
    
    setFormData({
      name: '',
      email: '',
      phone: '',
      message: '',
    })
  }

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  const contactInfo = [
    {
      icon: Phone,
      title: 'Phone',
      content: '720.538.0225',
      link: 'tel:7205380225',
    },
    {
      icon: Mail,
      title: 'Email',
      content: 'service@refugecommunityoutreach.org',
      link: 'mailto:service@refugecommunityoutreach.org',
    },
    {
      icon: MapPin,
      title: 'Address',
      content: '14241 E 4th Avenue Ste. 5-260, Aurora, CO 80011',
      link: 'https://maps.google.com/?q=14241+E+4th+Avenue+Ste.+5-260+Aurora+CO+80011',
    },
  ]

  return (
    <div className="min-h-screen" data-component-path="client/src/pages/Contact.jsx" data-component-line="1:1" data-component-id="client/src/pages/Contact.jsx:1:1">
      <section className="bg-gradient-to-br from-auburn-50 via-white to-stone-50 py-20" data-component-path="client/src/pages/Contact.jsx" data-component-line="3:3" data-component-id="client/src/pages/Contact.jsx:3:3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/Contact.jsx" data-component-line="4:4" data-component-id="client/src/pages/Contact.jsx:4:4">
          <div className="text-center max-w-3xl mx-auto" data-component-path="client/src/pages/Contact.jsx" data-component-line="5:5" data-component-id="client/src/pages/Contact.jsx:5:5">
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6" data-component-path="client/src/pages/Contact.jsx" data-component-line="6:6" data-component-id="client/src/pages/Contact.jsx:6:6">Contact Us</h1>
            <p className="text-xl text-gray-600 leading-relaxed" data-component-path="client/src/pages/Contact.jsx" data-component-line="7:7" data-component-id="client/src/pages/Contact.jsx:7:7">
              We're here to answer your questions and help you get started with compassionate in-home care
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white" data-component-path="client/src/pages/Contact.jsx" data-component-line="16:16" data-component-id="client/src/pages/Contact.jsx:16:16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/Contact.jsx" data-component-line="17:17" data-component-id="client/src/pages/Contact.jsx:17:17">
          <div className="grid md:grid-cols-3 gap-8 mb-20" data-component-path="client/src/pages/Contact.jsx" data-component-line="18:18" data-component-id="client/src/pages/Contact.jsx:18:18">
            {contactInfo.map((info, index) => (
              <a
                key={index}
                href={info.link}
                target={info.icon === MapPin ? '_blank' : undefined}
                rel={info.icon === MapPin ? 'noopener noreferrer' : undefined}
                className="bg-stone-50 p-8 rounded-xl hover:shadow-lg transition-shadow duration-200 border border-gray-200 flex flex-col items-center text-center gap-4"
                data-component-path="client/src/pages/Contact.jsx"
                data-component-line="19:19"
                data-component-id="client/src/pages/Contact.jsx:19:19"
              >
                <div className="w-16 h-16 bg-auburn-100 rounded-full flex items-center justify-center flex-shrink-0" data-component-path="client/src/pages/Contact.jsx" data-component-line="27:27" data-component-id="client/src/pages/Contact.jsx:27:27">
                  <info.icon className="w-8 h-8 text-auburn-600" data-component-path="client/src/pages/Contact.jsx" data-component-line="28:28" data-component-id="client/src/pages/Contact.jsx:28:28" />
                </div>
                <div data-component-path="client/src/pages/Contact.jsx" data-component-line="30:30" data-component-id="client/src/pages/Contact.jsx:30:30">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-component-path="client/src/pages/Contact.jsx" data-component-line="31:31" data-component-id="client/src/pages/Contact.jsx:31:31">{info.title}</h3>
                  <p className="text-gray-600" data-component-path="client/src/pages/Contact.jsx" data-component-line="32:32" data-component-id="client/src/pages/Contact.jsx:32:32">{info.content}</p>
                </div>
              </a>
            ))}
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-start" data-component-path="client/src/pages/Contact.jsx" data-component-line="39:39" data-component-id="client/src/pages/Contact.jsx:39:39">
            <div className="flex flex-col gap-6" data-component-path="client/src/pages/Contact.jsx" data-component-line="40:40" data-component-id="client/src/pages/Contact.jsx:40:40">
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900" data-component-path="client/src/pages/Contact.jsx" data-component-line="41:41" data-component-id="client/src/pages/Contact.jsx:41:41">
                Request Services
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed" data-component-path="client/src/pages/Contact.jsx" data-component-line="44:44" data-component-id="client/src/pages/Contact.jsx:44:44">
                Fill out the form below and we'll get back to you as soon as possible to discuss your care needs and answer any questions you may have.
              </p>
              <div className="bg-auburn-50 p-6 rounded-xl border border-auburn-200" data-component-path="client/src/pages/Contact.jsx" data-component-line="47:47" data-component-id="client/src/pages/Contact.jsx:47:47">
                <div className="flex items-start gap-3" data-component-path="client/src/pages/Contact.jsx" data-component-line="48:48" data-component-id="client/src/pages/Contact.jsx:48:48">
                  <Clock className="w-6 h-6 text-auburn-600 flex-shrink-0 mt-0.5" data-component-path="client/src/pages/Contact.jsx" data-component-line="49:49" data-component-id="client/src/pages/Contact.jsx:49:49" />
                  <div data-component-path="client/src/pages/Contact.jsx" data-component-line="50:50" data-component-id="client/src/pages/Contact.jsx:50:50">
                    <h3 className="font-bold text-gray-900 mb-2" data-component-path="client/src/pages/Contact.jsx" data-component-line="51:51" data-component-id="client/src/pages/Contact.jsx:51:51">Response Time</h3>
                    <p className="text-gray-700" data-component-path="client/src/pages/Contact.jsx" data-component-line="52:52" data-component-id="client/src/pages/Contact.jsx:52:52">
                      We typically respond to all inquiries within 24 hours during business days.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <form onSubmit={handleSubmit} className="bg-white p-8 rounded-xl shadow-lg border border-gray-200" data-component-path="client/src/pages/Contact.jsx" data-component-line="60:60" data-component-id="client/src/pages/Contact.jsx:60:60">
              <div className="flex flex-col gap-6" data-component-path="client/src/pages/Contact.jsx" data-component-line="61:61" data-component-id="client/src/pages/Contact.jsx:61:61">
                <div data-component-path="client/src/pages/Contact.jsx" data-component-line="62:62" data-component-id="client/src/pages/Contact.jsx:62:62">
                  <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-2" data-component-path="client/src/pages/Contact.jsx" data-component-line="63:63" data-component-id="client/src/pages/Contact.jsx:63:63">
                    Full Name *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full h-11 px-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-auburn-500 focus:border-auburn-500 transition-colors duration-200"
                    placeholder="John Doe"
                    data-component-path="client/src/pages/Contact.jsx"
                    data-component-line="66:66"
                    data-component-id="client/src/pages/Contact.jsx:66:66"
                  />
                </div>

                <div data-component-path="client/src/pages/Contact.jsx" data-component-line="78:78" data-component-id="client/src/pages/Contact.jsx:78:78">
                  <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2" data-component-path="client/src/pages/Contact.jsx" data-component-line="79:79" data-component-id="client/src/pages/Contact.jsx:79:79">
                    Email Address *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full h-11 px-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-auburn-500 focus:border-auburn-500 transition-colors duration-200"
                    placeholder="john@example.com"
                    data-component-path="client/src/pages/Contact.jsx"
                    data-component-line="82:82"
                    data-component-id="client/src/pages/Contact.jsx:82:82"
                  />
                </div>

                <div data-component-path="client/src/pages/Contact.jsx" data-component-line="94:94" data-component-id="client/src/pages/Contact.jsx:94:94">
                  <label htmlFor="phone" className="block text-sm font-semibold text-gray-700 mb-2" data-component-path="client/src/pages/Contact.jsx" data-component-line="95:95" data-component-id="client/src/pages/Contact.jsx:95:95">
                    Phone Number *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="w-full h-11 px-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-auburn-500 focus:border-auburn-500 transition-colors duration-200"
                    placeholder="(720) 555-0123"
                    data-component-path="client/src/pages/Contact.jsx"
                    data-component-line="98:98"
                    data-component-id="client/src/pages/Contact.jsx:98:98"
                  />
                </div>

                <div data-component-path="client/src/pages/Contact.jsx" data-component-line="110:110" data-component-id="client/src/pages/Contact.jsx:110:110">
                  <label htmlFor="message" className="block text-sm font-semibold text-gray-700 mb-2" data-component-path="client/src/pages/Contact.jsx" data-component-line="111:111" data-component-id="client/src/pages/Contact.jsx:111:111">
                    Message *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="5"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-auburn-500 focus:border-auburn-500 transition-colors duration-200 resize-none"
                    placeholder="Tell us about your care needs..."
                    data-component-path="client/src/pages/Contact.jsx"
                    data-component-line="114:114"
                    data-component-id="client/src/pages/Contact.jsx:114:114"
                  />
                </div>

                <button
                  type="submit"
                  className="flex items-center justify-center gap-2 h-11 px-6 bg-auburn-600 text-white rounded-lg hover:bg-auburn-700 transition-all duration-200 shadow-md hover:shadow-lg focus:ring-4 focus:ring-auburn-300/50 font-semibold"
                  data-component-path="client/src/pages/Contact.jsx"
                  data-component-line="127:127"
                  data-component-id="client/src/pages/Contact.jsx:127:127"
                >
                  <Send className="w-5 h-5 flex-shrink-0" data-component-path="client/src/pages/Contact.jsx" data-component-line="132:132" data-component-id="client/src/pages/Contact.jsx:132:132" />
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Contact